import Layout from '../Layout'

export default [
  {
    path: "/logout",
    name: "logout",
    component: Layout
  }
];
